"use client";

import { c as _c } from "react/compiler-runtime";
import { setClientAuthCookie } from "@/shared/lib/client-auth-cookie";
import { useEffect, useState } from "react";
import { useAuthContext } from "@/app/providers/AuthProviders";
import { useQueryUserInterest } from "@/entities/user/hooks/useUser";
import { useQueryUserInfo } from "@/entities/user/hooks/useSignIn";
import { InterestSelectModal } from "@/features/home/ui/organisms";
import useDataStore from "@/features/home/model/data/store";
const InterestSelectGate = () => {
  const $ = _c(10);
  const {
    loggedIn
  } = useAuthContext();
  const [dismissed, setDismissed] = useState(false);
  const {
    isViewInterestSelectModalIndex
  } = useDataStore();
  const t0 = !!loggedIn;
  let t1;
  if ($[0] !== t0) {
    t1 = {
      enabled: t0
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    data: userInfo
  } = useQueryUserInfo(t1);
  const t2 = !!loggedIn;
  let t3;
  if ($[2] !== t2) {
    t3 = {
      select: _temp,
      enabled: t2
    };
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    data: userInterest,
    isSuccess
  } = useQueryUserInterest(t3);
  let t4;
  let t5;
  if ($[4] !== userInfo) {
    t4 = () => {
      if (userInfo?.result) {
        setClientAuthCookie("userInfo", JSON.stringify({
          userName: userInfo.result.userName,
          email: userInfo.result.email
        }), {
          expires: 30,
          sameSite: "lax"
        });
      }
    };
    t5 = [userInfo];
    $[4] = userInfo;
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  useEffect(t4, t5);
  if (isViewInterestSelectModalIndex === 2) {
    return null;
  }
  const t6 = isSuccess && userInterest?.shouldOpen && !dismissed;
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setDismissed(true);
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t6) {
    t8 = <InterestSelectModal open={t6} onClose={t7} />;
    $[8] = t6;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  return t8;
};
export default InterestSelectGate;
function _temp(data) {
  const interests = data.result.interests;
  return {
    shouldOpen: interests.dermatology.length === 0 && interests.dentistry.length === 0 && interests.plasticSurgery.length === 0
  };
}